"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slatePlugins = require("@udecode/slate-plugins");
var _components = require("../../components");
var _isUrl = _interopRequireDefault(require("../../../../utils/isUrl"));
var defaultLink = {
  link: {
    component: _components.Link,
    type: _slatePlugins.ELEMENT_LINK,
    isUrl: _isUrl["default"],
    rootProps: {
      className: 'slate-link'
    }
  }
};
var _default = exports["default"] = defaultLink;